var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import FileUpload from "~/components/common/file-upload.vue";
import { DataRepairImportService } from "~/services/repair-service/data-repair-import.service";
var DataImport = /** @class */ (function (_super) {
    __extends(DataImport, _super);
    function DataImport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.fileList = [];
        _this.kosekiModel = {
            fileId: "",
            importContentType: "",
            hasPicture: ""
        };
        return _this;
    }
    DataImport.prototype.success = function () {
        this.close();
    };
    DataImport.prototype.close = function () {
        this.reset();
    };
    DataImport.prototype.created = function () { };
    DataImport.prototype.onUploadSuccess = function (id, data) {
        this.kosekiModel.fileId = data.id;
        this.kosekiModel.importContentType = this.importType;
    };
    // 添加新凭证
    DataImport.prototype.CreatedDetail = function () {
        var _this = this;
        this.loading.state = true;
        if (this.fileList.length === 0) {
            this.$message('请上传导入文件');
            return;
        }
        if (this.flag) {
            this.kosekiModel.hasPicture = "YES";
        }
        else {
            delete this.kosekiModel.hasPicture;
        }
        this.dataRepairImportService
            .import(this.kosekiModel)
            .subscribe(function (data) {
            _this.$message.success('上传成功!');
            _this.success();
        });
    };
    /**
     * keep-alive生命周期钩子函数
     */
    DataImport.prototype.activated = function () {
        // 加载数据
    };
    DataImport.prototype.reset = function () {
        var fileForm = this.$refs['file-upload'];
        fileForm.reset();
        var form = this.$refs['created-form'];
        form.resetFields();
        this.kosekiModel.hasPicture = "";
    };
    __decorate([
        Dependencies(DataRepairImportService)
    ], DataImport.prototype, "dataRepairImportService", void 0);
    __decorate([
        Emit("success")
    ], DataImport.prototype, "success", null);
    __decorate([
        Emit("close")
    ], DataImport.prototype, "close", null);
    __decorate([
        Prop()
    ], DataImport.prototype, "importType", void 0);
    __decorate([
        Prop()
    ], DataImport.prototype, "flag", void 0);
    DataImport = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], DataImport);
    return DataImport;
}(Vue));
export default DataImport;
